import {isNotNullOrUndefined} from '@wandb/weave/common/util/types';
import {chain} from 'lodash';
import {useMemo} from 'react';

import {useCrossProjectRunsProjectsQuery} from '../../../generated/graphql';
import {useViewer} from '../../../state/viewer/hooks';

export type ProjectOption = {
  entityName: string;
  name: string;
  internalId: string;
};

export const useCrossProjectOptions = (
  entityName: string,
  queryString: string
): {
  loading: boolean;
  options: ProjectOption[];
} => {
  const viewer = useViewer();
  const {data, loading} = useCrossProjectRunsProjectsQuery({
    variables: {
      entityName,
      userName: viewer?.username ?? '',
      pattern: queryString,
    },
  });

  const options = useMemo(() => {
    const entityProjects = data?.entity?.projects?.edges.map(e => e.node) ?? [];
    const viewerProjects = data?.viewer?.projects?.edges.map(e => e.node) ?? [];
    const userProjects =
      data?.user?.teams?.edges.flatMap(edge =>
        edge.node?.projects?.edges.map(e => e.node)
      ) ?? [];

    return chain(userProjects)
      .concat(viewerProjects)
      .concat(entityProjects)
      .filter(isNotNullOrUndefined)
      .uniqBy(p => p.internalId)
      .orderBy(p => p.createdAt, 'desc')
      .map(p => ({
        entityName: p.entityName,
        name: p.name,
        internalId: p.internalId,
      }))
      .value();
  }, [data]);

  return {loading, options};
};
